import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { KmsOrganizationType } from '@/@types/kms'
import { useDIDAccount } from '@/hooks/useDIDAccount'
import { useSetStateKmsOrgs } from '@/jotai/account'
import { useStateCurrentWorkspaceId } from '@/jotai/workspace'
import { getKmsOrganizations } from '@/lib/kms'

export const useWorkspace = () => {
  const { did } = useDIDAccount()
  const [currentWorkspaceId, setCurrentWorkspaceId] = useStateCurrentWorkspaceId()
  const setStateKmsOrgs = useSetStateKmsOrgs()

  const { data: workspaces, isInitialLoading: isLoadingOrg } = useQuery<KmsOrganizationType[]>(
    ['kmsOrganizations'],
    () => fetchOrganizationFromKMS(),
    {
      enabled: !!did && did !== '',
      staleTime: Infinity,
      cacheTime: 300000,
      retry: false,
    },
  )

  const fetchOrganizationFromKMS = async () => {
    try {
      const orgs = await getKmsOrganizations()
      console.log({ orgs })
      setStateKmsOrgs(orgs)
      return orgs
    } catch (error) {
      console.error({ error })
      return []
    }
  }

  const workspace = useMemo(() => {
    if (!workspaces || workspaces.length === 0) return null
    if (currentWorkspaceId) {
      return workspaces?.find((ws) => ws.id === currentWorkspaceId) || workspaces[0]
    }
    setCurrentWorkspaceId(workspaces[0].id)
    return workspaces[0]
  }, [workspaces, currentWorkspaceId])

  return {
    isLoadingOrg,
    workspace,
    workspaces,
    setCurrentWorkspaceId,
  }
}
